import FlexBox from '@/atomic-components/FlexBox';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import {
	BlockLineItem,
	LineItemStyles,
	Breakup,
} from '@/services/cart/models/cart';
import { getStyle } from '@/utils/theme/fonts';
import { SxProps, Box } from '@mui/material';
import { ReactElement } from 'react';

type Align = 'inherit' | 'left' | 'center' | 'right' | 'justify';

const alignmentConversionMap = new Map([
	['left', 'left' as Align],
	['right', 'right' as Align],
	['middle', 'center' as Align],
]);

export const generateLineItem = (blockLineItem: BlockLineItem) => {
	const positionMap: any = {
		left: [],
		middle: [],
		right: [],
	};

	if (blockLineItem.subComponents?.length == 0) return;

	blockLineItem.subComponents.forEach((subComponent, index) => {
		positionMap[subComponent.alignment].push(
			<LencoTypography
				width='auto'
				textAlign={reduceTextAlignment(subComponent.alignment) as Align}
				p='0px 2px'
				sx={reduceStyle(subComponent.styles)}
			>
				{subComponent.value}
			</LencoTypography>
		);
	});

	return (
		<FlexBox p='4px 0px' fullWidth justifyContent='space-between'>
			<FlexBox>{positionMap.left.map((item: ReactElement) => item)}</FlexBox>
			<FlexBox>{positionMap.middle.map((item: ReactElement) => item)}</FlexBox>
			<FlexBox>{positionMap.right.map((item: ReactElement) => item)}</FlexBox>
		</FlexBox>
	);
};

export const reduceTextAlignment = (alignment: string): Align => {
	return alignmentConversionMap.get(alignment) ?? ('center' as Align);
};

export const reduceStyle = (styles: LineItemStyles): SxProps => {
	return {
		lineHeight: 1,
		...styles,
		...getStyle(styles?.fontSizeWeight?.replace('-', '_')),
		...(styles?.strikedThrough && { textDecoration: 'line-through' }),
	};
};

export const generateBlockOfBreakup = (block: Breakup) => (
	// this could be cart item, or summary
	<Box
		p='0px 24px'
		sx={{
			backgroundColor: block.backgroundColor,
		}}
	>
		<Box
			p='12px 0px'
			sx={{
				...(block.preceedingSeparator && {
					borderBottom: 'dashed 1px #BCBCBC',
				}),
			}}
		>
			{block.blockLineItems?.map((blockLineItem) => {
				return generateLineItem(blockLineItem);
			})}
		</Box>
	</Box>
);